import { IconButton, Typography, useOverlayContext } from 'seagull';
import { InfoLiner12 } from 'seagull/icons';
import { ResponsiveModal } from "../../components/ResponsiveModal";
import { useResponsive } from "../../contexts";
import ServiceDescriptionContent from "../../../components/ServiceDescriptionContent/ServiceDescriptionContent";
import styles from "./ServiceItem.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServiceItem(_ref) {
  let {
    name,
    description,
    variablePriceText,
    testId,
    includedServices
  } = _ref;
  const {
    showModal
  } = useOverlayContext();
  const {
    isDesktop
  } = useResponsive();
  const hasDescription = !!(description || includedServices !== null && includedServices !== void 0 && includedServices.some(s => s.description));
  return /*#__PURE__*/_jsxs("li", {
    className: styles.serviceDetails,
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.nameContainer,
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph3",
        children: [name, hasDescription && /*#__PURE__*/_jsx(IconButton, {
          noPadding: true,
          skin: "transparent",
          className: styles.icon,
          "data-testid": "".concat(testId, "-tooltip"),
          onClick: () => {
            showModal({
              closeOnClickOutside: true,
              closeOnEscapeKey: true,
              content: _ref2 => {
                let {
                  dismissModal
                } = _ref2;
                return /*#__PURE__*/_jsx(ResponsiveModal, {
                  isDesktop: isDesktop,
                  title: "".concat(name, " description"),
                  backTitle: "Back to packages",
                  primaryButtonLabel: "Close",
                  onPrimaryButtonClick: dismissModal,
                  onClose: dismissModal,
                  children: /*#__PURE__*/_jsx(ServiceDescriptionContent, {
                    description: description || '',
                    includedServices: includedServices,
                    testId: testId
                  })
                });
              }
            });
          },
          children: /*#__PURE__*/_jsx(InfoLiner12, {})
        }), includedServices && /*#__PURE__*/_jsx("ul", {
          className: styles.packageBundleServices,
          "data-testid": "".concat(testId, "-includedServices"),
          children: includedServices.map(_ref3 => {
            let {
              name
            } = _ref3;
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "paragraph3",
                as: "span",
                children: name
              })
            }, name);
          })
        })]
      })
    }), variablePriceText && /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph3",
      style: {
        textAlign: 'end'
      },
      "data-testid": "".concat(testId, "-price"),
      children: variablePriceText
    })]
  });
}